// Pharmelo AI client service. Fetches from the backend API proxy.

export async function askAI(
  userMessage: string | any[], 
  systemInstruction?: string, 
  onChunk?: (chunk: string) => void,
  history?: { role: string; content: string }[],
  model?: string
) {
  console.log("Pharmelo AI Request Started (Proxy):", { userMessage, model: model || 'default', historyLength: history?.length ?? 0 });
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 180000);

  try {
    const response = await fetch('/api/ai', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      signal: controller.signal,
      body: JSON.stringify({ userMessage, systemInstruction, history, model })
    });

    clearTimeout(timeoutId);
    
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP ${response.status}`);
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let fullResponse = "";
    let buffer = "";

    if (reader) {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        
        // Keep the last (potentially incomplete) line in the buffer
        buffer = lines.pop() || "";
        
        for (const line of lines) {
          const trimmed = line.trim();
          if (trimmed.startsWith('data: ')) {
            const dataStr = trimmed.slice(6);
            if (dataStr === '[DONE]') continue;
            try {
              const data = JSON.parse(dataStr);
              const content = data.choices[0]?.delta?.content || "";
              if (content) {
                fullResponse += content;
                if (onChunk) onChunk(content);
              }
            } catch (e) {
              console.error("Error parsing stream chunk", e, trimmed);
            }
          }
        }
      }
    }

    return fullResponse;

  } catch (error) {
    clearTimeout(timeoutId);
    console.error("AI Request Failed:", error);
    
    if (error instanceof Error && error.name === 'AbortError') {
      return "The Pharmelo AI is taking a while to think... please try again in a moment!";
    }

    return "Oops! I hit a snag connecting to the Pharmelo AI. Please check your connection or API key.";
  }
}
